import { getMyCourses } from './my-courses-api';
import type { MyCoursesDataI } from './my-courses-api';

export type DashboardCoursesDataI = MyCoursesDataI;

export const getDashboardCourses = () => getMyCourses({});
